import React from 'react';
import {Button, ButtonGroup} from "reactstrap";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faAngleRight, faAngleLeft} from '@fortawesome/free-solid-svg-icons';
import LearningSubHeader from "../learning-components/LearningSubHeader";
import Layout from "../../Layout";
import Task from "../components/Task";
import useAssignmentData from "../hooks/useAssignmentData";
import {menuPart1ItemsFlatten, menuPart2ItemsFlatten} from './navigationConfig'

const Assignment = ({match}) => {
    const [showCorrectAnswers, setShowCorrectAnswers] = React.useState(false);
    const {data, name, status} = useAssignmentData(match.params.id);

    const getPreviousAndNextTasksFromArray = (values, id) => {
        const searchIndex = values.findIndex((value) => String(value.id) === id);
        const previousIndex = searchIndex - 1;
        const nextIndex = searchIndex + 1;
        return [values[previousIndex] || -1, values[nextIndex] || -1];
    }

    const getTasksPartInfo = () => {
        switch (match.params.id.charAt(0)) {
            case '1':
                return [menuPart1ItemsFlatten, '1']
            case '2':
                return [menuPart2ItemsFlatten, '2']
            default:
                return [[], false]
        }
    }

    const renderBottomNavigation = () => {
        const [menuItems, part] = getTasksPartInfo();
        const [previousTask, nextTask] = getPreviousAndNextTasksFromArray(menuItems, match.params.id);

        return <ButtonGroup className="d-flex justify-content-end">
            <Button outline color="secondary" disabled={previousTask === -1}
                    href={`/mokomoji-priemone/${part}-dalis/${previousTask.id}`}>
                <FontAwesomeIcon size="sm" icon={faAngleLeft}/> {previousTask.title}
            </Button>
            <Button outline color="info"
                    onClick={() => setShowCorrectAnswers(!showCorrectAnswers)}>
                Pasitikrinti
            </Button>
            <Button outline color="secondary" disabled={nextTask === -1}
                    href={`/mokomoji-priemone/${part}-dalis/${nextTask.id}`}>
                {nextTask.title} <FontAwesomeIcon size="sm" icon={faAngleRight}/>
            </Button>
        </ButtonGroup>
    }

    const renderTasks = () => {
        switch (status) {
            case 'completed': {
                return <>{data.map((task, index) => (<Task {...task} key={index} showCorrect={showCorrectAnswers}/>))}
                    {renderBottomNavigation()}
                </>
            }

            case 'failed': {
                return <>Užduoties parodyti nepavyko.</>
            }

            default:
            case 'processing': {
                return <>Kraunama...</>;
            }
        }
    }

    return <Layout className="home">
        <LearningSubHeader/>
        <div className="m-5">
            <h4>{name}</h4>
            {renderTasks()}
        </div>
    </Layout>
}

export default Assignment;